import React from "react";
import UserMenu from "./Profile/UserProfile";
import "./Header.css";

import logo from "../../Assets/logo.png";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  Option,
  makeStyles,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  Button,

} from "@fluentui/react-components";
import { LocalLanguage24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  root: {
    display: "grid",
    gridTemplateRows: "repeat(1fr)",
    justifyItems: "start",
    gap: "2px",
    maxWidth: "400px",
  },
});

const Header = (props) => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  
  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  const handleTenantChange = (event, data) => {
    const selectedTenantId = data.optionValue;
    
    // Sauvegarder dans sessionStorage (supprimé à la fermeture de l'onglet)
    sessionStorage.setItem('activeTenantId', selectedTenantId);
    
    // Mettre à jour Redux
    props.setActiveTenant(selectedTenantId);
  };

  // Trouver le nom du tenant actif pour l'afficher
  const selectedTenant = props.partnerTenants?.find(
    tenant => tenant.tenantId === props.ACTIVE_TENANT
  );
  const displayValue = selectedTenant?.customerName || t("SELECT_TENANT");

  return (
    <div className="header">
      <div className="logo-container">
        <img src={logo} alt="Heedify Logo" className="logo" />
      </div>
   
      <div className="header-right">
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <Button
              className="language-button"
              appearance="plain"
              shape="square"
              title="Change Language"
            >
              {i18n.language.toUpperCase()}
            </Button>
          </MenuTrigger>
          <MenuPopover className="menu-popover-class" >
            <MenuList>
              <MenuItem 
                onClick={() => handleLanguageChange('en')}
                style={{
                  backgroundColor: i18n.language === 'en' ? '#E0CFFC' : 'transparent',
                  fontWeight: i18n.language === 'en' ? '600' : 'normal'
                }}
              >
                En
              </MenuItem>
              <MenuItem 
                onClick={() => handleLanguageChange('fr')}
                style={{
                  backgroundColor: i18n.language === 'fr' ? '#E0CFFC' : 'transparent',
                  fontWeight: i18n.language === 'fr' ? '600' : 'normal'
                }}
              >
                Fr
              </MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
        <div className={styles.root}>
          <Dropdown
            onOptionSelect={handleTenantChange}
            clearable
            className="dropdown-style"
            placeholder={t("SELECT_TENANT")}
            value={displayValue}
            selectedOptions={props.ACTIVE_TENANT ? [props.ACTIVE_TENANT] : []}
          >
            {/* Dynamically generate options from partner tenants */}
            {props.partnerTenants && props.partnerTenants.length > 0 ? (
              props.partnerTenants.map((tenant) => (
                <Option key={tenant.tenantId} value={tenant.tenantId}>
                  {tenant.customerName}
                </Option>
              ))
            ) : (
              <Option disabled>No tenants available</Option>
            )}
          </Dropdown>
        </div>
        {/* User profile menu */}
        <UserMenu />
      </div>
    </div>
  );
};

export default Header;
